import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { AnswerText } from './AnswerText';
import { dotSx } from './motion';

type Props = { text: string; isRunning: boolean };

/** The answer while it streams: each checked block fades in, and dots show more is coming.
 */
export function LiveDraft({ text, isRunning }: Props) {
  // Before the first sentence, shimmering lines hold the answer's place so the wait reads as progress.
  if (!text) {
    return isRunning ? (
      <Stack aria-hidden sx={{ gap: 0.75, maxWidth: 520, pt: 0.5 }}>
        {['100%', '88%', '60%'].map((width, i) => (
          <Skeleton key={width} animation="wave" variant="rounded" width={width} height={10} sx={{ borderRadius: 1, animationDelay: `${i * 120}ms` }} />
        ))}
      </Stack>
    ) : null;
  }
  return (
    <Stack sx={{ gap: 0.5 }}>
      <AnswerText text={text} citations={[]} isLive />
      {isRunning ? (
        <Box role="status" aria-label="Writing" sx={{ height: 12 }}>
          {[0, 0.15, 0.3].map((delay) => (
            <Box component="span" key={delay} sx={{ ...dotSx, animationDelay: `${delay}s` }} />
          ))}
        </Box>
      ) : null}
    </Stack>
  );
}
